import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Chip } from "@mui/material";
import "./SkillsDetailModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import { fonts, themes } from "../../../themes/themes";
import Compdirection from "../../../themes/CompDirection";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackSelectedSkills: (data: any) => void;
  allSuggestedSkills: any;
  selectedEmployeeDetail: any;
  trans?: any;
}

const PopupModalPresenter = ({
  isModalOpen,
  closeModal,
  allSuggestedSkills,
  selectedEmployeeDetail,
  trans,
  callBackSelectedSkills,
}: ModalProps) => {
  const [skill, setSkill] = useState("");
  const [selectedSkills, setSelectedSkills] = useState<any>([]);

  const handleSuggestedSkills = (skillName: any) => {
    const tempArray: any = [...selectedSkills];
    const foundElement = tempArray.find(
      (skill: any) => skill.name == skillName.name
    );

    if (tempArray.length === 0) {
      tempArray.push(skillName);
    } else {
      if (typeof foundElement !== "undefined") {
        _.remove(tempArray, (skill: any) => {
          return skill.name == skillName.name;
        });
      } else {
        tempArray.push(skillName);
      }
    }

    setSelectedSkills(tempArray);
  };
  const handleSubmit = () => {
    if (selectedSkills.length == 0) {
      callBackSelectedSkills(skill);
    } else {
      callBackSelectedSkills(selectedSkills);
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="464px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans("Add Skills") }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid container style={{ marginTop: "20px" }}>
          <Grid item xs={12}>
            <CustomTextField
              type="string"
              label={trans("Skills")}
              placeholder={trans("Write skills here")}
              value={skill}
              onChange={(e: any) => setSkill(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} style={{ marginTop: "1em" }}>
            <Box
              style={{
                padding: "1em",
                background: "#FAFAFA 0% 0% no-repeat padding-box",
                border: "1px solid #0000001A",
                borderRadius: "8px",
                height: "160px",
                width: "auto",
                font: fonts.fontFamily,
                color: themes.blackDefault,
                fontWeight: "bolder",
              }}
            >
              <Typography fontFamily={fonts.fontFamily}>
                {trans("Suggested based on your profile")}
              </Typography>
              <Grid container spacing={2} style={{ marginTop: "0.8em" }}>
                {_.map(allSuggestedSkills, (skill: any) => {
                  let isFound = false;
                  selectedSkills?.filter((s: any) => {
                    if (skill.name == s.name) {
                      isFound = true;
                    }
                  });
                  return (
                    <Grid item xs={3}>
                      <Chip
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: "12px",
                          color: isFound ? "#7c0e6f" : "black",
                          cursor: "pointer",
                        }}
                        label={skill.name}
                        onClick={() => handleSuggestedSkills(skill)}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Compdirection>

      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default PopupModalPresenter;
